<template>
  <div class="d-grid-4-24">
    <!-- 스킬패스 고객사 ? 스킬패스 : 온라인클래스 -->
    <div
      v-if="isSkillPath"
      class="cursor-pointer"
      @click.prevent="goToMicroLearning"
      @keypress.prevent="goToMicroLearning"
    >
      <div class="info-blocks lectureRed" tabindex="0">
        <div
          class="t-headline4 t-color-lectureRed font-b t-center pdt-34 pdb-33 t-line-h-45"
        >
          {{ microLearning }}
        </div>
      </div>
      <div class="mgt-8 t-center t-color-bodyGrayA font-r t-body1">
        {{ $t("3761") }}
      </div>
    </div>
    <div
      v-else
      class="cursor-pointer"
      @click.prevent="goToLearning"
      @keypress.prevent="goToLearning"
    >
      <div class="info-blocks lectureRed" tabindex="0">
        <div
          class="t-headline4 t-color-lectureRed font-b t-center pdt-34 pdb-33 t-line-h-45"
        >
          {{ learning }}
        </div>
      </div>
      <div class="mgt-8 t-center t-color-bodyGrayA font-r t-body1">
        {{ $t("3762") }}
      </div>
    </div>

    <!-- 스킬패스 고객사 ? 학습 중 : 수료 -->
    <div
      v-if="isSkillPath"
      class="cursor-pointer"
      @click.prevent="goToLearning"
      @keypress.prevent="goToLearning"
    >
      <div class="info-blocks lecturePurple" tabindex="0">
        <div
          class="t-headline4 t-color-lecturePurple font-b t-center pdt-34 pdb-33 t-line-h-45"
        >
          {{ learning }}
        </div>
      </div>
      <div class="mgt-8 t-center t-color-bodyGrayA font-r t-body1">
        {{ $t("3762") }}
      </div>
    </div>
    <div
      v-else
      class="cursor-pointer"
      @click.prevent="goToCompletion"
      @keypress.prevent="goToCompletion"
    >
      <div class="info-blocks lecturePurple" tabindex="0">
        <div
          class="t-headline4 t-color-lecturePurple font-b t-center pdt-34 pdb-33 t-line-h-45"
        >
          {{ completion }}
        </div>
      </div>
      <div class="mgt-8 t-center t-color-bodyGrayA font-r t-body1">
        {{ $t("1739") }}
      </div>
    </div>

    <!-- 시험 -->
    <div
      class="cursor-pointer"
      @click.prevent="goToMyTest"
      @keypress.prevent="goToMyTest"
    >
      <div class="info-blocks contentBlue" tabindex="0">
        <div
          class="t-headline4 t-color-contentBlue font-b t-center pdt-34 pdb-33 t-line-h-45"
        >
          {{ eaxmTest }}
        </div>
      </div>
      <div class="mgt-8 t-center t-color-bodyGrayA font-r t-body1">
        {{ $t("1740") }}
      </div>
    </div>

    <!-- 서베이 -->
    <div
      class="cursor-pointer"
      @click.prevent="goToMySurvey"
      @keypress.prevent="goToMySurvey"
    >
      <div class="info-blocks lectureAqua" tabindex="0">
        <div
          class="t-headline4 t-color-lectureAqua font-b t-center pdt-34 pdb-33 t-line-h-45"
        >
          {{ survey }}
        </div>
      </div>
      <div class="mgt-8 t-center t-color-bodyGrayA font-r t-body1">
        {{ $t("1741") }}
      </div>
    </div>
  </div>
</template>

<script>
import localStorageUtil from "@/utils/localStorageUtil.js";

export default {
  name: "MyInformationCurrentStudy",
  props: [
    "goToMicroLearning",
    "microLearning",
    "goToLearning",
    "learning",
    "goToCompletion",
    "completion",
    "goToMyTest",
    "eaxmTest",
    "goToMySurvey",
    "survey",
  ],
  data() {
    return {
      isSkillPath: localStorageUtil.isSkillPath(),
    };
  },
};
</script>

<style>
</style>